export default __webpack_public_path__ + "static/media/detail_mobile_11_7.86064dbf.jpg";